import { render, staticRenderFns } from "./HeroInfoStandalone.vue?vue&type=template&id=7034badf&scoped=true&"
import script from "./HeroInfoStandalone.vue?vue&type=script&lang=js&"
export * from "./HeroInfoStandalone.vue?vue&type=script&lang=js&"
import style0 from "./HeroInfoStandalone.vue?vue&type=style&index=0&id=7034badf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7034badf",
  null
  
)

export default component.exports